import { render, staticRenderFns } from "./EditPermission.vue?vue&type=template&id=1cdc0d0a&"
import script from "./EditPermission.vue?vue&type=script&lang=js&"
export * from "./EditPermission.vue?vue&type=script&lang=js&"
import style0 from "./EditPermission.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports